import MainSideBar from "../../../navigation/MainSidebar";
import "./Base.scss";
import { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
// import SearchIcon from "../../../images/Search.svg";
import { defaultOptions1 } from "../../../../config/loading-config.js";
import ProjectSidebar from "../../project/ProjectSidebar";
import ProjectGrid from "../../project/ProjectGrid";
import "../../project/Home.scss";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
// import ProfilePic from "../../../images/ProfilePic.svg";
// import DropDownIcon from "../../../images/Arrow-Down.svg";
import ToggleIcon from "../../../../images/toggle-icon.svg";
// import MyAccountIcon from "../../../images/My-Account-icon.svg";
// import LogoutIcon from "../../../images/Logout-icon.svg";

const Base = ({ mainContent, adminView }) => {
  useEffect(() => {
  }, []);

  return (
    <>
      {/* <div className="safeaps-home-wrapper">
      <Container fluid>
        <Row>
          <Col md={1}>
            <div className="main-sidebar-pane">
              <MainSideBar adminView={adminView} />
            </div>
          </Col>
          <Col>
            <div className="project-content-pane">{mainContent}</div>
          </Col>
        </Row>
      </Container>
    </div> */}

      <div class="dashboard">
        <MainSideBar adminView={false} />

        <Container fluid>
          <div class="dashboard-app">
            <header className="dashboard-toolbar">
              <a href="#!" class="menu-toggle">
                <img src={ToggleIcon} alt="Menu toggle icon" />
              </a>
              <div>{"Last Successful Login 25 Nov 2021 | 09:34 GMT+3"}</div>

              <NavDropdown
                title={
                  <span>
                    {/* <img src={ProfilePic} alt="Profile picture" /> */}
                    <img
                      // src={safeAp.profileImg.content}
                      width="44"
                      height="44"
                      style={{
                        borderRadius: "50%",
                        border: "2px solid #85CFFA",
                      }}
                      alt="Profile picture"
                    />
                    {/* &nbsp;{`${safeAp.fullName.first} ${safeAp.fullName.last}`} */}
                  </span>
                }
                id="collasible-nav-dropdown"
                className="menu-profile-pic"
              >
                {/* <NavDropdown.Item href="#action/3.1" onClick={profileFunc}>
                  <img src={MyAccountIcon} alt="" />
                  &nbsp;&nbsp;Profile
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.1" onClick={accountFunc}>
                  <img src={MyAccountIcon} alt="" />
                  &nbsp;&nbsp;My Account
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2" onClick={logoutFunc}>
                  <img src={LogoutIcon} alt="" />
                  &nbsp;&nbsp;Logout
                </NavDropdown.Item> */}
              </NavDropdown>
            </header>

            <div className="dashboard-content">
              {/* <ProjectGrid
                projectType={projectType}
                safeAp={safeAp}
                safeApId={safeApId}
                filterBySearch={filterBySearch}
                filteredProjects={filteredProjects}
                setFilteredProjects={setFilteredProjects}
                isLoading={isLoading}
              /> */}
              {mainContent}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Base;
